import { render, staticRenderFns } from "./ChatRegionGroupSide.vue?vue&type=template&id=8f6fab16&scoped=true"
import script from "./ChatRegionGroupSide.vue?vue&type=script&lang=js"
export * from "./ChatRegionGroupSide.vue?vue&type=script&lang=js"
import style0 from "./ChatRegionGroupSide.vue?vue&type=style&index=0&id=8f6fab16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6fab16",
  null
  
)

export default component.exports